import styled from 'styled-components';

export const OptionsBox = styled.div`
  display: flex;
  background: #ddd;
  margin-bottom: 5px;
  font-size: 13px;
  justify-content: space-between;
`;

export const ProfileBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

export const ProfileName = styled.span`
  display: inline-block;
  margin-left: 5px;
`;

export const SettingsBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SettingsButton = styled.div`
  cursor: pointer;
  padding: 9px;
  &:hover {
    background: #909090;
  }
  & i {
    font-size: 16px;
  }
`;
